/**
 * @file: 框选矩形
 * @author: xiaolong.huang@dmall.com
 */

import Utils from '../../utils/util';
import ShortCutKey from '../shortcutkey/index';

let dragStatus: DragStatus = 'over';
let globalEventIsBind: boolean = false;

class DrawRect {
    private dragStartX: number;
    private dragStartY: number;
    private dragEndX: number;
    private dragEndY: number;
    private $rect: JQuery<HTMLElement>;
    private $sketchpad: JQuery<HTMLElement>;
    private $mask: JQuery<HTMLElement>;
    private $win: JQuery<Window>;
    private startLeft: number;
    private startTop: number;
    private eDown: boolean;
    private mousedown: boolean;
    private rect: Rect;
    private selectCallback: (...args) => void;
    private startCallback: (...args) => void;

    constructor() {
        this.eDown = false;
        this.mousedown = false;
        this.rect = {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
    }

    init(): void {
        this.bindDragEvent();
        this.$sketchpad = $('.shelvesbuild-e-sketchpad');
        this.$rect = $('#shelvesbuild__select-rect');
        this.$mask = $('#shelvesbuild-e-sketchpad__e-mask');
    }

    onSelected(callback: (...args) => void): void {
        this.selectCallback = callback;
    }

    onStart(callback: (...args) => void): void {
        this.startCallback = callback;
    }

    private bindDragEvent(): void {
        if (globalEventIsBind) {
            return;
        }
        globalEventIsBind = true;
        this.$win = $(window);
        this.createProtect();
        this.down();
        this.move();
        this.up();
    }

    private down(): void {
        this.$win.bind('mousedown', (ev: JQuery.MouseDownEvent): void => {
            let $target: JQuery<EventTarget> = $(ev.target);

            // 鼠标中键禁用
            if (ev.button === 1 || ev.button === 3) {
                return;
            }

            if ($target.hasClass('shelvesbuild-e-sketchpad__zoom-mask')) {
                return;
            }

            if (!$target.hasClass('shelvesbuild-e-sketchpad')
                && !$target.hasClass('shelvesbuild-e-sketchpad__e-mask')) {
                return;
            }
            let sketchpadPos: JQuery.Coordinates = this.$sketchpad.offset();

            this.$mask.addClass('show');
            this.startLeft = sketchpadPos.left;
            this.startTop = sketchpadPos.top;
            dragStatus = 'start';
            this.dragStartX = ev.clientX;
            this.dragStartY = ev.clientY;
            this.mousedown = true;
        });
    }

    private move(): void {
        this.$win.bind('mousemove', (ev: JQuery.MouseMoveEvent): any => {
            if (dragStatus === 'over') {
                return;
            }
            if (dragStatus === 'start') {
                this.startCallback && this.startCallback();
            }
            dragStatus = 'drag';
            this.dragEndX = ev.clientX;
            this.dragEndY = ev.clientY;
            this.drawRect();
            return false;
        });
    }

    private up(): void {
        this.$win.bind('mouseup', (ev: JQuery.MouseUpEvent): void => {
            this.mousedown = false;
            this.removeMask();
            dragStatus = 'over';
            this.isMove() && this.selectCallback && this.selectCallback({
                ...this.rect
            });
            this.clear();
        });
    }

    private removeMask(): void {
        if (!this.eDown && !this.mousedown) {
            this.$mask.removeClass('show');
            while (this.$mask.hasClass('show')) {
                this.$mask.removeClass('show');
            }
            setTimeout(() => {
                this.$mask.removeClass('show');
            }, 10);
        }
    }

    private isMove(): boolean {
        return !!this.rect.width || !!this.rect.height;
    }

    private createProtect(): void {
        let self: DrawRect = this;
        let $win: JQuery<Window> = $(window);

        $win.bind('keydown', function(e: JQuery.KeyDownEvent): any {
            if (e.keyCode !== 69) {
                return;
            }
            self.eDown = true;
            self.$mask.addClass('show');
        });
        $win.bind('keyup', function(e: JQuery.KeyUpEvent): any {
            if (e.keyCode !== 69) {
                return;
            }
            self.eDown = false;
            self.removeMask();
        });
    }

    private drawRect(): void {
        let width: number = Utils.math(this.dragEndX, this.dragStartX, '-');
        let height: number = Utils.math(this.dragEndY, this.dragStartY, '-');
        let left: number = Utils.math(this.dragStartX, this.startLeft, '-');
        let top: number = Utils.math(this.dragStartY, this.startTop, '-');

        if (width < 0) {
            left = Utils.math(left, Math.abs(width), '-');
        }

        if (height < 0) {
            top = Utils.math(top, Math.abs(height), '-');
        }

        this.$rect.css({
            transform: `translate(${left}px, ${top}px)`,
            width: `${Math.abs(width)}px`,
            height: `${Math.abs(height)}px`
        });
        this.rect = {
            left,
            top,
            width: Math.abs(width),
            height: Math.abs(height)
        };
    }

    private clear(): void {
        this.$rect && this.$rect.css({
            transform: 'translate(0, 0)',
            width: 0,
            height: 0
        });
        this.rect = {
            left: 0,
            top: 0,
            width: 0,
            height: 0
        };
    }
};

export default new DrawRect();
